import comment from '../../snippets/comment';

export default ({keys, merchant}) => `<?php

require 'vendor/autoload.php';
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');

header('Content-Type: application/json');

try {
  // retrieve JSON from POST body
  $json_str = file_get_contents('php://input');
  $json_obj = json_decode($json_str);

  {+capture-intent-endpoint}
  $intent = \\Stripe\\PaymentIntent::retrieve($json_obj->id);
  {span response capture-intent-endpoint}$intent{/span} = $intent->capture();
  {/capture-intent-endpoint}

  echo json_encode($intent);

} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
